import * as types from './Types.js';

export function findObra(entidade, exercicioObra, idOrdemServico) {
  return ({ fetch }) => ({
    type: types.OBRA,
    payload: {
      promise: fetch(
        `/api/obras?entidade=${entidade}&exercicioObra=${exercicioObra}&idOrdemServico=${idOrdemServico}`
      )
    }
  });
}

export function searchObras(filter) {
  let url = '/api/obras';

  if (filter !== '') {
    url += '?' + filter;
  }

  return ({ fetch }) => ({
    type: types.CONSULTA_OBRAS,
    payload: {
      promise: fetch(url)
    }
  });
}

export function resetConsulta() {
  return {
    type: types.RESET_CONSULTA_OBRAS,
    payload: {}
  };
}

export function loadSituacoes() {
  return ({ fetch }) => ({
    type: types.SITUACOES_OBRAS,
    payload: {
      data: { text: 'Buscando registros...' },
      promise: fetch('/api/obras/situacoes')
    }
  });
}

export function findMedicoes(entidade, exercicioObra, idOrdemServico) {
  return ({ fetch }) => ({
    type: types.MEDICOES,
    payload: {
      promise: fetch(
        `/api/obras/medicoes?entidade=${entidade}&exercicioObra=${exercicioObra}&idOrdemServico=${idOrdemServico}`
      )
    }
  });
}

export function findOrdemArquivos(entidade, exercicioObra, idOrdemServico) {
  return ({ fetch }) => ({
    type: types.ORDEM_ARQUIVOS,
    payload: {
      promise: fetch(
        `/api/obras/ordens-arquivos?entidade=${entidade}&exercicioObra=${exercicioObra}&idOrdemServico=${idOrdemServico}`
      )
    }
  });
}

export function findPlanilhas(entidade, exercicioObra, idOrdemServico) {
  return ({ fetch }) => ({
    type: types.PLANILHAS,
    payload: {
      promise: fetch(
        `/api/obras/planilhas?entidade=${entidade}&exercicioObra=${exercicioObra}&idOrdemServico=${idOrdemServico}`
      )
    }
  });
}

export function findImagens(
  entidade,
  exercicioMedicao,
  idOrdemServico,
  sequencia
) {
  return ({ fetch }) => ({
    type: types.IMAGENS,
    payload: {
      promise: fetch(
        `/api/obras/imagens?entidade=${entidade}&exercicioMedicao=${exercicioMedicao}&idOrdemServico=${idOrdemServico}&sequencia=${sequencia}`
      )
    }
  });
}

export function findEmpenhos(entidade, exercicioObra, idOrdemServico) {
  return ({ fetch }) => ({
    type: types.OBRA_EMPENHOS,
    payload: {
      promise: fetch(
        `/api/obras/empenhos?entidade=${entidade}&exercicioObra=${exercicioObra}&idOrdemServico=${idOrdemServico}`
      )
    }
  });
}
